module.exports = __webpack_public_path__ + "static/media/ic_proyectos_truck_pin.4dab2f19.svg";